import { Avatar, IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useState } from 'react';
import { IoIosArrowForward } from 'react-icons/io';
import SearchIcon from '@mui/icons-material/Search';
import { useIntl } from 'react-intl';

const ParticipantsSlider = ({ handleclose, isOpen, selectedMeeting, userdetails }) =>
{
	const [ serarchUser, setserarchUser ]=useState(true);
	const emailToRemove = selectedMeeting?.extra?.email;
	const updatedInvities = selectedMeeting?.invities.filter((email) => email !== emailToRemove);
	const [ participants, setParticipants ]=useState(updatedInvities);

	const intl = useIntl();

	const handlechange=(e) =>
	{
		const searchValue=e.target.value.toLowerCase();

		const filteredParticipants = updatedInvities.filter((participant) =>
			participant.toLowerCase().includes(searchValue)
		);
		const filterhost = selectedMeeting?.extra?.name.toLowerCase().includes(searchValue);

		console.log('filterhost==', filterhost);
		setserarchUser(filterhost);
		setParticipants(filteredParticipants);
	};
	const url = userdetails?.data?.profileImage?.url;

	console.log('url of image ..', participants);

	return (
		<div className='flexCol'>
			{/* <div className={`overlay ${isOpen ? 'open' : ''}`} onClick={handleclose}></div>
            <div className={`slider flexCol pdngMD whiteBg ${isOpen ? 'open' : ''}`}> */}
			{/* <div className={isOpen ? 'overlay fadeInOverlay' : ''} onClick={handleclose} /> */}
			{/* <div className={isOpen ? 'flexCol slider slideIn pdngSM whiteBg' : 'flexCol slider pdngSM whiteBg'}> */}
			<div className='flexAutoCol'>
				<div className='flexRow aCntr'>
					<div className='flexAutoRow pointer' onClick={handleclose}><IoIosArrowForward className='primaryTxt' fontSize={'25px'} /></div>
					<div className='flexMinWidthRow jCntr'><span className='headingxsmall'>{intl.formatMessage({ id: 'label.participants', defaultMessage: 'Participants' })}</span></div>
				</div>
			</div>
			<div className='flexAutoCol pdngTLG'>
				<TextField
					fullWidth
					variant='standard'
					onChange={handlechange}
					InputProps={{
						startAdornment : (
							<InputAdornment position='start'>
								<SearchIcon color='action' />
							</InputAdornment>
						)
					}}
					placeholder='Search by name '
				/>
			</div>
			<div className='flexMinHeightCol pdngTMD'>
				{serarchUser && <div className='flexRow aCntr brdrsliderbottom pdngBXS'>
					<div className='flexAutoRow'>
						{/* <img
							style={{ width: 50, height: 50 }}
							className='mPimg'
							src={userdetails?.data?.profileImage?.url}
							alt='profile_img'
						/> */}
						{			url ?	<Avatar sx={{ width: 50, height: 50 }} src={url} />
							:<Avatar sx={{ width: 50, height: 50 }}>{selectedMeeting?.extra?.name.slice(0, 1).toUpperCase()}</Avatar>}
					</div>
					<div className='flexMinWidthRow pdngLXS'>
						<div className='flexAutoCol'>
							<span className='textsizeSm'>{selectedMeeting?.extra?.name} (Host)</span>
							{/* <div className='flexInline'>
								<span className='logoTxt2'>Joined at :</span>
								<span className='pdngLXXS logoTxt2'>10:32 AM</span>
							</div> */}
						</div>
					</div>
				</div>}
				<div className='flexMinHeightCol scrollYAuto'>
					{participants.length > 0 || serarchUser? participants.map((item, value) => (
						<div className='flexRow aCntr brdrsliderbottom pdngVXS' key={value}>
							<div className='flexAutoRow'><Avatar sx={{ width: 28, height: 28 }} key={item+value}>{item[0]?.toUpperCase()}</Avatar></div>
							<div className='flexMinWidthRow pdngLXS'>
								<div className='flexAutoCol'>
									<span className='textsizeSm'>{item}</span>
									{/*  capitalizeTxt*/}
									{/* <div className='flexInline'>
										<span className='logoTxt2'>Joined at :</span>
										<span className='pdngLXXS logoTxt2'>{item.time}</span>
									</div> */}
								</div>
							</div>
						</div>
					)):(<div className='invities aCntr jCntr fullH'>
						<div className='flexInline'>
							<img
								src='/images/noResult.svg'
								alt=''
								className='noParticipantImg'
							/>
						</div>
						<span> No Invitees Found</span>
					</div>)
					}
				</div>
			</div>
		</div>
	// </div>
	);
};

export default ParticipantsSlider;
